import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "./components/theme-provider";
import emailjs from '@emailjs/browser';

// EmailJS Configuration from CONTACT_FORM_IMPLEMENTATION.md
const EMAILJS_PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || "QesNkzN9uKs75_2WH";

// Initialize EmailJS globally
emailjs.init(EMAILJS_PUBLIC_KEY);

createRoot(document.getElementById("root")!).render(
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <App />
    </ThemeProvider>
);
